export default {
    auth: {
        "signOut": "Выйти",
        "signIn": "Войти",
        "identify": "Пройти идентификацию",
        "authentication": "Авторизация",
        "identification": "Идентификация",
        "fillingExample": "Пример заполнения",
        "pinExample": "Пример ПИНа",
        "photoExample": "Пример фото",
        "yourPin": "Ваш ПИН",
        "yourPassportPin": "14-значный номер указан в вашем паспорте",
        "yourPhoto": "Ваше фото",
        "identificationExample": "Расположите лицо так, как указано в примере и нажмите на кнопку “Начать идентификацию”",
        "startIdentification": "Начать идентификацию",
        "identificationSuccess": "Идентификация пройдена",
        "EkyzmatAuth": "Войти через E-KYZMAT",
    },
    locale: {
        "ky_KG": "кыр",
        "ru_RU": "рус",
    },
    validation: {
        "requiredField": "Необходимо заполнить это поле",
        "wrongEmail": "Не правильная эл. почта",
        "wrongFormMsg": "Проверьте правильность введенных данных",
        "fileTypeMustBeImage": "Выбран не правильный файл",
        "saveSuccessMsg": "Успешно сохранено",
    },
    roles: {
        "roles": "Роли",
        "save": "Сохранить",
        "cancel": "Отмена",
        "foundWithQuantity": "По вашему запросу найдено {0} ролей",
        "name": "Название",
        "search": "Поиск",
        "edit": "Редактировать",
        "permissions": "Разрешения",
        "levels": "Роли",
        "languages": "Языки",
    },
    language: {
        "key": "Ключ",
    },
    users: {
        "settings": "Настройки",
    },
    errors: {
        "pageForbidden": "У вас нет доступа к данной странице",
        "pageNotFound": "Страница не найдена",
        "serverError": "Что то пошло не так, сообщите администратору",
        "error": "Ошибка"
    },
    app: {
        "ky_locale":"ky_KG",
        "ru_locale":"ru_RU",
        "close": "Закрыть",
        "ky_KG": "Кыргызча",
        "ru_RU": "Русский",
        "home": "Главная",
        "testing": "Тестирование",
        "description": "Социальная парадигма верифицирует современный механизм власти. Согласно классификации М.Вебера, марксизм иллюстрирует либерализм.",
        "saveSuccessMsg": "Успешно сохранено!",
        "noInternetConnection": "Проверьте подключение к интернету",
    },
    datePicker: {
        "mon": "Пн",
        "tue": "Вт",
        "wed": "Ср",
        "thu": "Чт",
        "fri": "Пт",
        "sat": "Сб",
        "sun": "Вс",
        "january": "Январь",
        "february": "Февраль",
        "march": "Март",
        "april": "Апрель",
        "may": "Май",
        "june": "Июнь",
        "july": "Июль",
        "august": "Август",
        "september": "Сентябрь",
        "october": "Октябрь",
        "november": "Ноябрь",
        "december": "Декабрь",
        "nextMonth": "След. месяц",
        "prevMonth": "Пред. месяц",
        "setTime": "Указать время",
        "format": "дд.мм.гггг"
    },
    pagination: {
        "previous": "Предыдущая",
        "next": "Следующая"
    },
    languages: {
        "languages": "Переводы",
        "handbooks": "handbooks",
        "statistics": "Статистика",
        "reports": "Отчеты",
        "questions": "Вопросы",
        "tests": "Тесты",
        "graphic": "График",
        "key": "Ключ",
        "resultFound": "По вашему запросу найдено результатов ",
        "levels": "Роли",
        "save": "Сохранить",
        "add": "Добавить",
        "cancel": "Отмена",
        "edit": "Редактировать",
        "delete": "Удалить",
        "update": "Обновить",
        "requiredField": "Необходимо заполнить это поле",
        "required": "Обьязательные поля",
        "wrongEmail": "Не правильная эл. почта",
        "wrongFormMsg": "Проверьте правильность введенных данных",
        "fileTypeMustBeImage": "Выбран не правильный файл",
        "saveSuccessMsg": "Успешно сохранено",
        "signOut": "Выйти",
        "signIn": "Войти",
        "identify": "Пройти идентификацию",
        "authentication": "Авторизация",
        "identification": "Идентификация",
        "fillingExample": "Пример заполнения",
        "pinExample": "Пример ПИНа",
        "photoExample": "Пример фото",
        "yourPin": "Ваш ПИН",
        "yourPinExample": "14-значный номер указан в вашем паспорте",
        "yourPhoto": "Ваше фото",
        "identificationExample": "Расположите лицо так, как указано в примере и нажмите на кнопку “Начать идентификацию”",
        "startIdentification": "Начать идентификацию",
        "identificationSuccess": "Идентификация пройдена",
        "EkyzmatAuth": "Войти через E-KYZMAT",
        "settings": "Настройки",
        "pageForbidden": "У вас нет доступа к данной странице",
        "pageNotFound": "Страница не найдена",
        "serverError": "Что то пошло не так, сообщите администратору",
        "error": "Ошибка",
        "close": "Закрыть",
        "ky_KG": "Кыргызча",
        "ru_RU": "Русский",
        "home": "Главная",
        "testing": "Тестирование",
        "testingKG": "Сынак",
        "description": "Социальная парадигма верифицирует современный механизм власти. Согласно классификации М.Вебера, марксизм иллюстрирует либерализм.",
        "noInternetConnection": "Проверьте подключение к интернету",
        "previous": "Предыдущая",
        "next": "Следующая",
        "actions": "Действия",
        "deleteSuccessMsg": "Успешно удалено!",
        "updateSuccessMsg": "Успешно обновлено!",
        "admin": "Админка",
        "searchPhrase": "Поиск фразы",
    },
}
